{
  "title": "Enter the dojo 🥷",
  "startLabelingButton": "Let's Start Labeling 🚀"
}
